module.exports = __webpack_public_path__ + "img/LogotipoLatinoSeguros.9a920eb3.png";